export const HOS_VIOLATIONS = {
  duty_12: $localize`12 Hour Shift Limit`,
  duty_14: $localize`14 Hour Shift Limit`,
  duty_16: $localize`16 Hour Shift Limit`,
  driving_11: $localize`11 Hour Driving Limit`,
  break_30: $localize`30 Minute Break Required`,
  cycle_60: $localize`60 Hour Cycle Limit`,
  cycle_70: $localize`70 Hour Cycle Limit`,
  duty_15: $localize`15 Hour On Duty Limit`,
  driving_10: $localize`10 Hour Driving Limit`,
  cycle_60_p: $localize`60 Hour Cycle Limit`,
  cycle_70_p: $localize`70 Hour Cycle Limit`,
  canada_duty_14: $localize`14 Hour On Duty Limit`,
  canada_duty_16: $localize`16 Hour Shift Limit`,
  canada_duty_18: $localize`18 Hour On Duty Limit`,
  canada_duty_20: $localize`20 Hour Shift Limit`,
  canada_daily_break_8: $localize`Daily 8 Hours Off Duty Required`,
  canada_driving_13: $localize`13 Hour Driving Limit`,
  canada_driving_15: $localize`15 Hour Driving Limit`,
  canada_daily_duty_14: $localize`Daily 14 Hour On Duty Limit`,
  canada_daily_driving_13: $localize`Daily 13 Hour Driving Limit`,
  canada_daily_break_10: $localize`Daily 10 Hours Off Duty Required`,
  canada_cycle_70: $localize`70 Hour Cycle Limit`,
  canada_cycle_80: $localize`80 Hour Cycle Limit`,
  canada_cycle_120: $localize`120 Hour Cycle Limit`,
  canada_break_24: $localize`24 Hour Break Required`,
  canada_break_24_70: $localize`24 Hour Break Required`,
  canada_break_24_80: $localize`24 Hour Break Required`,
  canada_oil_driving_13: $localize`13 Hour Driving Limit`,
  canada_oil_duty_14: $localize`14 Hour On Duty Limit`,
  canada_oil_duty_16: $localize`16 Hour Shift Limit`,
  canada_oil_break_3_24: $localize`Three 24 Hour Breaks Required`,
  canada_oil_daily_driving_13: $localize`Daily 13 Hour Driving Limit`,
  canada_oil_daily_duty_14: $localize`Daily 14 Hour On Duty Limit`,
  canada_oil_daily_break_10: $localize`Daily 10 Hours Off Duty Required`,
  ca_driving_12: $localize`12 Hour Driving Limit`,
  ca_duty_16: $localize`16 Hour Shift Limit`,
  ca_cycle_80: $localize`80 Hour Cycle Limit`,
  ca_driving_10: $localize`10 Hour Driving Limit`,
  ca_duty_15: $localize`15 Hour On Duty Limit`,
  ca_duty_16_p: $localize`16 Hour On Duty Limit`,
  ca_cycle_80_p: $localize`80 Hour Cycle Limit`,
  tx_driving_12: $localize`12 Hour Driving Limit`,
  tx_duty_15: $localize`15 Hour On Duty Limit`,
  tx_cycle_70: $localize`70 Hour Cycle Limit`,
  ak_cycle_70: $localize`70 Hour Cycle Limit`,
  ak_cycle_80: $localize`80 Hour Cycle Limit`,
  ak_duty_20: $localize`20 Hour Shift Limit`,
  ak_driving_15: $localize`15 Hour Driving Limit`,
  ak_cycle_70_p: $localize`70 Hour Cycle Limit`,
  ak_cycle_80_p: $localize`80 Hour Cycle Limit`,
  canada_daily_break_with_deferred_time: $localize`Did Not Take Deferred Time Off Duty`,
  canada_daily_driving_with_deferred_time: $localize`Exceeded Deferred Driving Limit`,
  canada_driving_26: $localize`Exceeded 26 Hour Driving Limit`,
  // new violations for short short haul dirvers
  short_haul_break_30: $localize`30 Minute Break Required`,
  short_haul_driving_11: $localize`11 Hour Driving Limit`,
  short_haul_duty_14: $localize`14 Hour Shift Limit`,
  short_haul_duty_16: $localize`16 Hour Shift Limit`,
  short_haul_cycle_60: $localize`60 Hour Cycle Limit`,
  short_haul_cycle_70: $localize`70 Hour Cycle Limit`,
  short_haul_driving_10_p: $localize`10 Hour Driving Limit`,
  short_haul_duty_14_p: $localize`14 Hour Shift Limit`,
  short_haul_duty_16_p: $localize`16 Hour Shift Limit`,
  short_haul_cycle_60_p: $localize`60 Hour Cycle Limit`,
  short_haul_cycle_70_p: $localize`70 Hour Cycle Limit`,
  alberta_driving_13: $localize`13 hour driving violation`,
  alberta_duty_15: $localize`15 hour on duty limit violation`,
  alberta_break_10: $localize`10 minute break violation`,
  alberta_break_30: $localize`30 minute break violation`,
  alberta_daily_break_with_reduced_rest: $localize`Daily Break With Reduced Time Required`,
  fl_driving_12: $localize`12 Hour Driving Limit`,
  fl_duty_16: $localize`16 Hour Shift Limit`,
  fl_cycle_70: $localize`70 Hour Cycle Limit`,
  fl_cycle_80: $localize`80 Hour Cycle Limit`,
  adverse_driving_duty_16: $localize`Adverse Driving 16 Hour Shift Limit`,
  adverse_driving_duty_17: $localize`Adverse Driving 17 Hour Shift Limit`,
  adverse_driving_duty_18: $localize`Adverse Driving 18 Hour Shift Limit`,
  adverse_driving_duty_22: $localize`Adverse Driving 22 Hour Shift Limit`,
  adverse_driving_drive_13: $localize`Adverse Driving 13 Hour Driving Limit`,
  adverse_driving_drive_12: $localize`Adverse Driving 12 Hour Driving Limit`,
  adverse_driving_drive_15: $localize`Adverse Driving 15 Hour Driving Limit`,
  adverse_driving_drive_17: $localize`Adverse Driving 17 Hour Driving Limit`,
  adverse_driving_drive_14: $localize`Adverse Driving 14 Hour Driving Limit`,
  adverse_driving_canada_daily_break_8: $localize`Daily 8 Hours Off Duty Required with Adverse Driving`,
  adverse_driving_canada_daily_driving_15: $localize`Adverse Driving Daily 15 Hour Driving Limit`,
  // Following case serves HosViolationPipe unit test
  unit_test_cycle: 'This Test is for HosViolationPipe Unit Test',
};

export const WHOLE_DAY_VIOLATIONS = ['canada_daily_break_10', 'canada_oil_daily_break_10'];
